export default __webpack_public_path__ + "static/media/Opposites02_07.dd5556ae.png";